import { PlanExpirationLevel } from '~/types/portal'

export const getTrialDaysLeft = (expirationDate: string): number => {
  const daysLeft = Math.round((new Date(expirationDate).getTime() - new Date().getTime()) / (1000 * 3600 * 24))
  return daysLeft > 0 ? daysLeft : 0
}

export const getPlanExpirationLevel = (daysLeft: number) => {
  if (daysLeft <= 3) {
    return PlanExpirationLevel.ERROR
  }
  if (daysLeft <= 7) {
    return PlanExpirationLevel.WARNING
  }
  return PlanExpirationLevel.INFO
}